
<v-flex xs12>
    <crm-entry-edit-dialog
        v-model="edit"
        :incident="incident"
        :entry="entry"
    />
    <v-card
        flat
        rounded
        class="crm-journal-card"
        :class="entryClass"
    >
        <crm-entry-readonly
            :entry     = "entry"
            :incident  = "incident"
            @edit      = "onEdit"
            @deleted   = "onDeleted"
            @undeleted = "onUnDeleted"
        />
    </v-card>
</v-flex>
